import PropTypes from 'prop-types';

export default function PlanningPassengerPhone({ phone }) {
  const value = String(phone ?? '').trim();
  const digits = value.replace(/\D/g, '');
  const local = /^55\d{10,11}$/.test(digits) ? digits.slice(2) : digits;
  const brazilian = (!value.startsWith('+') || digits.startsWith('55'))
    && local.match(/^(\d{2})(\d{4,5})(\d{4})$/);
  const display = brazilian ? `(${brazilian[1]}) ${brazilian[2]}-${brazilian[3]}` : value;
  return <p className="planning-passenger-phone">Telefone: {display || 'não informado'}</p>;
}

PlanningPassengerPhone.propTypes = { phone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) };
